import { render, staticRenderFns } from "./Part4.vue?vue&type=template&id=2c53fc35&scoped=true"
import script from "./Part4.vue?vue&type=script&lang=js"
export * from "./Part4.vue?vue&type=script&lang=js"
import style0 from "./Part4.vue?vue&type=style&index=0&id=2c53fc35&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c53fc35",
  null
  
)

export default component.exports